import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentCalledFinished from './ContentCalledFinished';

const CalledSent = () => {
  return (
    <>
      <Header />
      <ContentCalledFinished />
      <Bottom />
    </>
  );
};

export default CalledSent;
